module.exports = __webpack_public_path__ + "static/media/ic-van.b583c350.svg";